/**
 * Count compare items
 */

function countCompare() {
	const listItem = localStorage.getItem('compareItems').split(',');
	const listItemNew = listItem.filter((element) => element !== '');

	document.querySelectorAll('[data-type-count="compare"]').forEach((item) => {
		item.innerHTML = listItemNew.length;
	});
}

function showEmptyNote() {
	const itemsComparePage = document.querySelectorAll('#compare-grid .scroll-item');

	if (itemsComparePage.length <= 1) {
		document.getElementById('compare-grid').classList.add('compare-list__empty');
	}
}
/**
 * Add class added to items
 */
function compareAdded(element) {
	const productHandle = element.getAttribute('data-product-handle');
	var listItems = '';
	var listItemsArray = [];

	listItems = localStorage.getItem('compareItems');

	if (listItems) {
		listItemsArray = listItems.split(',');

		if (listItemsArray.includes(productHandle)) {
			element.classList.add('added');
		}
	}
}

/**
 * Remove added class
 */
function removeAddedItemClass(productHandle) {
	document.querySelectorAll('tpt-product-compare').forEach((item) => {
		if (item.getAttribute('data-product-handle') == productHandle) {
			item.classList.remove('added');
		}
	});
}

/**
 * Count compare
 */
window.addEventListener('DOMContentLoaded', () => {
	if (localStorage.getItem('compareItems') !== null) {
		countCompare();
	}
});

/**
 * Render compare modal
 */
function renderCompareModal(compareItemString) {
	const compareModal = document.getElementById('tpt-compare-modal');
	document.getElementById('tpt-modal-compare__render-list').innerHTML = '';

	if (compareItemString) {
		let opened = true;
		const listItemsArray = compareItemString.split(',');
		const newListItemsArray = listItemsArray.reverse();

		compareModal.classList.remove('compare-empty');

		newListItemsArray.forEach((handle) => {
			const urlProduct = window.Shopify.routes.root + 'products/' + handle + '?section_id=tpt-modal-compare-item';

			fetch(urlProduct)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					const productElement = responseHTML.querySelector('[id="shopify-section-tpt-modal-compare-item"]');

					document.getElementById('tpt-modal-compare__render-list').insertAdjacentHTML('beforeend', productElement.innerHTML);
				})
				.finally(() => {
					if (opened) {
						compareModal.classList.add('show');
						document.getElementsByTagName('html')[0].classList.add('open-modal');

						opened = false;

						setTimeout(() => {
							compareModal.focus();
						}, 300);
					}
				});
		});
	} else {
		compareModal.classList.add('show', 'compare-empty');
		document.getElementsByTagName('html')[0].classList.add('open-modal');
	}
}

/**
 * Add compare function
 */
class Compare extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.addCompare);
		compareAdded(this);
	}

	addCompare() {
		const productHandle = this.getAttribute('data-product-handle');
		this.classList.add('loading');

		var dataString = '';

		dataString = localStorage.getItem('compareItems');

		if (dataString) {
			var listItems = '';

			listItems = localStorage.getItem('compareItems');

			var listItemsArray = listItems.split(',');

			if (!listItemsArray.includes(productHandle)) {
				listItems = listItems + ',' + productHandle;
			}

			localStorage.setItem('compareItems', listItems);
			countCompare();
		} else {
			localStorage.setItem('compareItems', productHandle);
			countCompare();
		}

		setTimeout(() => {
			this.classList.remove('loading');
			this.classList.add('added');

			/**
			 * Show modal compare
			 */

			renderCompareModal(localStorage.getItem('compareItems'));
		}, 200);
	}
}

customElements.define('tpt-product-compare', Compare);

/**
 * Remove compare from compare list
 */
class RemoveCompare extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.removeCompareItem);
	}

	removeCompareItem() {
		const productHandleItem = this.getAttribute('data-remove-item');
		var listItem = [];
		var newListItemArray = [];

		listItem = localStorage.getItem('compareItems').split(',');

		newListItemArray = listItem.filter((item) => item !== productHandleItem);

		localStorage.setItem('compareItems', newListItemArray.toString());
		this.closest('.scroll-item').remove();
		countCompare();

		showEmptyNote();
	}
}

customElements.define('tpt-remove-compare', RemoveCompare);

/**
 * Remove compare in modal
 */

class RemoveCompareModal extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.removeCompareItemModal);
	}

	removeCompareItemModal() {
		const productHandleItem = this.getAttribute('data-remove-item');
		const compareModal = document.getElementById('tpt-compare-modal');
		var listItem = [];
		var newListItemArray = [];

		listItem = localStorage.getItem('compareItems').split(',');

		newListItemArray = listItem.filter((item) => item !== productHandleItem);

		localStorage.setItem('compareItems', newListItemArray.toString());
		this.closest('.tpt-compare-modal-item').remove();
		countCompare();
		removeAddedItemClass(productHandleItem);

		if (!localStorage.getItem('compareItems')) {
			compareModal.classList.add('compare-empty');
		}
	}
}

customElements.define('tpt-remove-compare-modal', RemoveCompareModal);

/**
 * Open modal compare
 */
class OpenModalCompareComponent extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		if (this.classList.contains('active')) {
			this.classList.remove('active');

			this.setAttribute('aria-expanded', false);

			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			modalComponent.classList.remove('show');

			return;
		} else {
			renderCompareModal(localStorage.getItem('compareItems'));

			this.classList.add('active');

			this.setAttribute('aria-expanded', true);

			document.getElementsByTagName('html')[0].classList.add('open-modal');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-open-modal-compare', OpenModalCompareComponent);
